import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services';
import { inject } from '@angular/core';
import { UserType } from '../enums';

export const adminRoleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  if (authService.getCurrentUser()?.userType === UserType.ADMIN) {
    return true;
  } else {
    router.navigateByUrl('/');
    return false;
  }
};
